// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import logo1 from "../../assets/Images/logo1.png";
// import { COMPANY_NAME_MAIN, COMPANY_NAME_SUBTITLE, COMPANY_TAGLINE } from '../../config/Constants';

// interface SplashScreenProps {
//   onComplete: () => void;
//   duration?: number;
// }

// const SplashScreen: React.FC<SplashScreenProps> = ({ 
//   onComplete, 
//   duration = 3000 
// }) => {
//   const [currentStage, setCurrentStage] = useState(0);
//   const [showContent, setShowContent] = useState(false);

//   useEffect(() => {
//     // Show content after a brief delay
//     const contentTimer = setTimeout(() => setShowContent(true), 200);
    
//     // Progress through animation stages
//     const stageTimer = setTimeout(() => setCurrentStage(1), 800);
//     const stage2Timer = setTimeout(() => setCurrentStage(2), 1600);
//     const stage3Timer = setTimeout(() => setCurrentStage(3), 2400);
    
//     // Complete splash screen
//     const completeTimer = setTimeout(() => {
//       setCurrentStage(4);
//       setTimeout(onComplete, 800); // Allow exit animation to complete
//     }, duration);

//     return () => {
//       clearTimeout(contentTimer);
//       clearTimeout(stageTimer);
//       clearTimeout(stage2Timer);
//       clearTimeout(stage3Timer);
//       clearTimeout(completeTimer);
//     };
//   }, [onComplete, duration]);

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: { 
//       opacity: 1,
//       transition: { duration: 0.8, ease: "easeOut" }
//     },
//     exit: { 
//       opacity: 0,
//       transition: { duration: 0.8, ease: "easeIn" }
//     }
//   };

//   const logoVariants = {
//     hidden: { 
//       scale: 0.8, 
//       opacity: 0,
//       rotateY: -90,
//       filter: "blur(10px)"
//     },
//     visible: { 
//       scale: 1, 
//       opacity: 1,
//       rotateY: 0,
//       filter: "blur(0px)",
//       transition: { 
//         duration: 1.2, 
//         ease: "easeOut",
//         delay: 0.3
//       }
//     },
//     pulse: {
//       scale: [1, 1.05, 1],
//       transition: {
//         duration: 2,
//         repeat: Infinity,
//         ease: "easeInOut"
//       }
//     },
//     exit: {
//       scale: 1.2,
//       opacity: 0,
//       transition: { duration: 0.6, ease: "easeIn" }
//     }
//   };

//   const textVariants = {
//     hidden: { opacity: 0, y: 30, scale: 0.9 },
//     visible: { 
//       opacity: 1, 
//       y: 0, 
//       scale: 1,
//       transition: { 
//         duration: 0.8, 
//         ease: "easeOut",
//         delay: 0.8
//       }
//     },
//     exit: { 
//       opacity: 0, 
//       y: -30,
//       transition: { duration: 0.6, ease: "easeIn" }
//     }
//   };

//   const progressVariants = {
//     hidden: { scaleX: 0 },
//     visible: { 
//       scaleX: 1,
//       transition: { 
//         duration: 2.5, 
//         ease: "easeInOut",
//         delay: 1.2
//       }
//     }
//   };

//   const floatingElements = [
//     { delay: 0, duration: 6, x: [0, 30, 0], y: [0, -20, 0] },
//     { delay: 0.5, duration: 8, x: [0, -25, 0], y: [0, 15, 0] },
//     { delay: 1, duration: 7, x: [0, 20, 0], y: [0, -25, 0] },
//     { delay: 1.5, duration: 9, x: [0, -30, 0], y: [0, 20, 0] }
//   ];

//   return (
//     <AnimatePresence mode="wait">
//       <motion.div
//         className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 overflow-hidden"
//         variants={containerVariants}
//         initial="hidden"
//         animate="visible"
//         exit="exit"
//       >
//         {/* Animated background elements */}
//         <div className="absolute inset-0">
//           {/* Floating geometric shapes */}
//           {floatingElements.map((element, index) => (
//             <motion.div
//               key={index}
//               className="absolute w-2 h-2 bg-blue-400/30 rounded-full"
//               style={{
//                 left: `${20 + index * 20}%`,
//                 top: `${30 + index * 15}%`,
//               }}
//               animate={{
//                 x: element.x,
//                 y: element.y,
//               }}
//               transition={{
//                 duration: element.duration,
//                 repeat: Infinity,
//                 ease: "easeInOut",
//                 delay: element.delay,
//               }}
//             />
//           ))}

//           {/* Subtle grid pattern */}
//           <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiM2M0I5RjQiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMSIvPjwvZz48L2c+PC9zdmc+')] opacity-20" />
//         </div>

//         {/* Main content container */}
//         <div className="relative z-10 text-center px-6">
//           {/* Logo with stunning animations */}
//           <motion.div
//             className="mb-8"
//             variants={logoVariants}
//             initial="hidden"
//             animate={currentStage >= 1 ? "visible" : "hidden"}
//             onAnimationComplete={() => {
//               if (currentStage >= 1) {
//                 setShowContent(true);
//               }
//             }}
//           >
//             <motion.div
//               animate={currentStage >= 1 ? "pulse" : "visible"}
//               className="relative"
//             >
//               {/* Glowing effect behind logo */}
//               <motion.div
//                 className="absolute inset-0 bg-blue-500/20 rounded-full blur-3xl"
//                 animate={{
//                   scale: [1, 1.2, 1],
//                   opacity: [0.3, 0.6, 0.3],
//                 }}
//                 transition={{
//                   duration: 3,
//                   repeat: Infinity,
//                   ease: "easeInOut",
//                 }}
//               />
              
//               {/* Main logo image */}
//               {/* <img
//                 src={logo1}
//                 alt={`${COMPANY_NAME_MAIN} Logo`}
//                 className="relative z-10 w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain drop-shadow-2xl"
//               /> */}
//             </motion.div>
//           </motion.div>

//           {/* Company name with elegant typography */}
//           <AnimatePresence>
//             {showContent && currentStage >= 2 && (
//               <motion.div
//                 variants={textVariants}
//                 initial="hidden"
//                 animate="visible"
//                 exit="exit"
//                 className="mb-6"
//               >
//                 <motion.div
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.8, delay: 1.0 }}
//                   className="mb-4 flex justify-center"
//                 >
//                   <motion.img
//                     src={logo1}
//                     alt={`${COMPANY_NAME_MAIN} Logo`}
//                     className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain drop-shadow-2xl"
//                   />
//                 </motion.div>
//                 <motion.h1
//                   className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-2"
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.8, delay: 1.0 }}
//                 >
//                   <span className="bg-gradient-to-r from-blue-400 via-white to-purple-400 bg-clip-text text-transparent">
//                     {COMPANY_NAME_MAIN}
//                   </span>
//                 </motion.h1>
                
//                 <motion.h2
//                   className="text-xl md:text-2xl lg:text-3xl font-semibold text-blue-200 mb-3"
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.8, delay: 1.2 }}
//                 >
//                   {COMPANY_NAME_SUBTITLE}
//                 </motion.h2>

//                 <motion.p
//                   className="text-lg md:text-xl text-blue-100/80 max-w-md mx-auto leading-relaxed"
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.8, delay: 1.4 }}
//                 >
//                   {COMPANY_TAGLINE}
//                 </motion.p>
//               </motion.div>
//             )}
//           </AnimatePresence>

//           {/* Progress bar */}
//           <AnimatePresence>
//             {showContent && currentStage >= 3 && (
//               <motion.div
//                 variants={textVariants}
//                 initial="hidden"
//                 animate="visible"
//                 exit="exit"
//                 className="w-64 md:w-80 mx-auto"
//               >
//                 <div className="relative">
//                   {/* Background track */}
//                   <div className="w-full h-2 bg-blue-900/50 rounded-full overflow-hidden">
//                     {/* Animated progress bar */}
//                     <motion.div
//                       className="h-full bg-gradient-to-r from-blue-400 via-purple-400 to-blue-600 rounded-full"
//                       variants={progressVariants}
//                       initial="hidden"
//                       animate="visible"
//                     />
//                   </div>
                  
//                   {/* Loading text */}
//                   <motion.p
//                     className="text-blue-200 text-sm mt-3 font-medium"
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ duration: 0.5, delay: 1.8 }}
//                   >
//                     Initializing...
//                   </motion.p>
//                 </div>
//               </motion.div>
//             )}
//           </AnimatePresence>

//           {/* Subtle loading dots */}
//           <AnimatePresence>
//             {showContent && currentStage >= 3 && (
//               <motion.div
//                 className="flex justify-center space-x-2 mt-6"
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 2.0 }}
//               >
//                 {[0, 1, 2].map((index) => (
//                   <motion.div
//                     key={index}
//                     className="w-2 h-2 bg-blue-400 rounded-full"
//                     animate={{
//                       scale: [1, 1.5, 1],
//                       opacity: [0.5, 1, 0.5],
//                     }}
//                     transition={{
//                       duration: 1.5,
//                       repeat: Infinity,
//                       delay: index * 0.2,
//                     }}
//                   />
//                 ))}
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </div>

//         {/* Exit animation overlay */}
//         <AnimatePresence>
//           {currentStage >= 4 && (
//             <motion.div
//               className="absolute inset-0 bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-600"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               transition={{ duration: 0.8 }}
//             />
//           )}
//         </AnimatePresence>
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// export default SplashScreen; 

// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import logo1 from "../../assets/Images/logo1.png";
// import { COMPANY_NAME_MAIN, COMPANY_NAME_SUBTITLE, COMPANY_TAGLINE } from "../../config/Constants";

// interface SplashScreenProps {
//   onComplete: () => void;
//   duration?: number;
// }

// const SplashScreen: React.FC<SplashScreenProps> = ({ 
//   onComplete, 
//   duration = 2200 // ⬅ shorter duration (2.2s instead of 3s)
// }) => {
//   const [showContent, setShowContent] = useState(false);
//   const [exit, setExit] = useState(false);

//   useEffect(() => {
//     const showTimer = setTimeout(() => setShowContent(true), 150); // faster show

//     // Complete splash screen and start exit animation
//     const completeTimer = setTimeout(() => {
//       setExit(true);
//       setTimeout(onComplete, 600); // wait for exit animation before navigating
//     }, duration);

//     return () => {
//       clearTimeout(showTimer);
//       clearTimeout(completeTimer);
//     };
//   }, [onComplete, duration]);

//   const fadeInUp = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
//     exit: { opacity: 0, y: -20, transition: { duration: 0.5 } },
//   };

//   return (
//     <AnimatePresence>
//       {!exit && (
//         <motion.div
//           className="fixed inset-0 z-50 flex items-center justify-center bg-black" // ⬅ dark bg, no gradient
//           initial={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <div className="text-center">
//             {/* Logo */}
//             <motion.img
//               src={logo1}
//               alt={`${COMPANY_NAME_MAIN} Logo`}
//               className="mx-auto w-28 h-28 md:w-36 md:h-36 lg:w-44 lg:h-44 object-contain drop-shadow-xl"
//               initial={{ scale: 0.8, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               transition={{ duration: 0.8, ease: "easeOut" }}
//             />

//             {showContent && (
//               <>
//                 {/* Company Name */}
//                 <motion.h1
//                   className="text-3xl md:text-4xl lg:text-5xl font-bold mt-4 text-white"
//                   variants={fadeInUp}
//                   initial="hidden"
//                   animate="visible"
//                   exit="exit"
//                 >
//                   {COMPANY_NAME_MAIN}
//                 </motion.h1>

//                 {/* Subtitle */}
//                 <motion.h2
//                   className="text-lg md:text-xl lg:text-2xl font-medium text-gray-300 mt-2"
//                   variants={fadeInUp}
//                   initial="hidden"
//                   animate="visible"
//                   exit="exit"
//                   transition={{ delay: 0.2 }}
//                 >
//                   {COMPANY_NAME_SUBTITLE}
//                 </motion.h2>

//                 {/* Tagline */}
//                 <motion.p
//                   className="text-sm md:text-base text-gray-400 mt-2"
//                   variants={fadeInUp}
//                   initial="hidden"
//                   animate="visible"
//                   exit="exit"
//                   transition={{ delay: 0.4 }}
//                 >
//                   {COMPANY_TAGLINE}
//                 </motion.p>

//                 {/* Loading Dots */}
//                 <motion.div
//                   className="flex justify-center mt-6 space-x-2"
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: 0.6 }}
//                 >
//                   {[0, 1, 2].map((i) => (
//                     <motion.div
//                       key={i}
//                       className="w-2 h-2 bg-white rounded-full"
//                       animate={{ opacity: [0.3, 1, 0.3], scale: [1, 1.3, 1] }}
//                       transition={{ repeat: Infinity, duration: 1.2, delay: i * 0.2 }}
//                     />
//                   ))}
//                 </motion.div>
//               </>
//             )}
//           </div>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// };

// export default SplashScreen;


import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo1 from "../../assets/Images/logo1.png";
import { COMPANY_NAME_MAIN, COMPANY_NAME_SUBTITLE, COMPANY_TAGLINE } from "../../config/Constants";

interface SplashScreenProps {
  onComplete: () => void;
  duration?: number;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ 
  onComplete, 
  duration = 2200 
}) => {
  const [stage, setStage] = useState<"splash" | "white" | "done">("splash");

  useEffect(() => {
    const splashTimer = setTimeout(() => setStage("white"), duration);
    const whiteTimer = setTimeout(() => {
      setStage("done");
      onComplete();
    }, duration + 800); // white screen lasts ~0.8s

    return () => {
      clearTimeout(splashTimer);
      clearTimeout(whiteTimer);
    };
  }, [onComplete, duration]);

  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.9 },
    visible: { 
      opacity: 1, 
      y: 0, 
      scale: 1,
      transition: { 
        duration: 0.8, 
        ease: "easeOut",
        delay: 0.8
      }
    },
    exit: { 
      opacity: 0, 
      y: -30,
      transition: { duration: 0.6, ease: "easeIn" }
    }
  };

  const progressVariants = {
    hidden: { scaleX: 0 },
    visible: { 
      scaleX: 1,
      transition: { 
        duration: 2.5, 
        ease: "easeInOut",
        delay: 1.2
      }
    }
  };

  return (
    <motion.div>
    <AnimatePresence>
      {stage === "splash" && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-center ">
            {/* Logo */}
            {/* <motion.img
              src={logo1}
              alt={`${COMPANY_NAME_MAIN} Logo`}
              className="relative z-10 w-33 h-33 md:w-40 md:h-40 lg:w-48 lg:h-48 
               object-contain drop-shadow-2xl mx-auto "
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            /> */}

            <motion.img
              src={logo1}
              alt={`${COMPANY_NAME_MAIN} Logo`}
              className="
                relative z-10 
                w-36 h-36 sm:w-44 sm:h-44 md:w-52 md:h-52 lg:w-60 lg:h-60 xl:w-72 xl:h-72
                object-contain 
                drop-shadow-2xl 
                mx-auto 
              "
              initial={{ scale: 0.8, opacity: 0 }}
                            

              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            />
            <motion.p
              className="text-sm md:text-lg 
                        text-gray-600 dark:text-gray-300 max-w-md mx-auto leading-relaxed mt-1"
              variants={fadeInUp}
              // style={{backgroundColor:'blue'}}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.4 }}
            >
              {COMPANY_TAGLINE}
            </motion.p>
              
            <div className="w-full h-2  rounded-full overflow-hidden">
              
              <motion.div
                className="h-full bg-gradient-to-r from-blue-600 via-yellow-400 to-blue-600 rounded-full"
                variants={progressVariants}
                initial="hidden"
                animate="visible"
              />
            </div>

          </div>
        </motion.div>
      )}
    </AnimatePresence>
    <AnimatePresence>            
        {/* <motion.div
          variants={textVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="w-64 md:w-80 mx-auto"
        >
          <div className="relative">
           
            <div className="w-full h-2 bg-blue-900/50 rounded-full overflow-hidden">
              
              <motion.div
                className="h-full bg-gradient-to-r from-blue-400 via-purple-400 to-blue-600 rounded-full"
                variants={progressVariants}
                initial="hidden"
                animate="visible"
              />
            </div>
          </div>
        </motion.div> */}
    </AnimatePresence>
    </motion.div>
  );
};

export default SplashScreen;
